import React, { useMemo } from "react";
import styled from "styled-components";
import { DepositsPolaris } from "../../components/admin/deposits/DepositsPolaris";
import { getPathFromRouter } from "../../helper";

const Container = styled.div`
    margin: -1rem;
    @media (min-width: 640px) {
        margin: -1.5rem;
    }
`;

export const DepositsPagePolaris = (...props) => {
    const path = useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);

    return (
        <Container>
            <DepositsPolaris path={path} />
        </Container>
    );
};
